import { parse } from 'date-fns';
import { DateFormatter } from 'infrastructure/functions';
import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { IMedication } from 'infrastructure/interfaces';

interface InfoRowProps {
  label: string;
  value: React.ReactNode;
  cy: string;
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value, cy }) => (
  <div className={s['body-left-row']}>
    <p>{label}</p>
    <p data-cy={cy}>{value}</p>
  </div>
);

interface MedicationInfoProps {
  item: IMedication;
}

const transformDate = (date: string | null) =>
  date ? DateFormatter({ date: parse(date, 'MMM dd yyyy', new Date()) }) : '';

export const MedicationInfo: React.FC<MedicationInfoProps> = ({ item }) => {
  const { t } = useTranslation();
  const fields: InfoRowProps[] = [
    {
      label: t('labels.route'),
      value: item.route ?? '',
      cy: 'medication-description-route',
    },
    {
      label: t('labels.duration'),
      value: item.duration ?? '',
      cy: 'medication-description-duration',
    },
    {
      label: t('labels.dose'),
      value: item.dosage ?? '',
      cy: 'medication-description-dosage',
    },
    {
      label: t('labels.startDate'),
      value: transformDate(item.startDate),
      cy: 'medication-description-startDate',
    },
    {
      label: t('labels.frequency'),
      value: item.frequency ?? '',
      cy: 'medication-description-frequency',
    },
    {
      label: t('labels.endDate'),
      value: transformDate(item.endDate),
      cy: 'medication-description-endDate',
    },
  ];

  return (
    <div className={s['body-left']}>
      {fields.map((f) => (
        <InfoRow key={f.cy} {...f} />
      ))}
    </div>
  );
};
